import React from 'react';

const FollowUpAgenciamentoContext = React.createContext();

export default FollowUpAgenciamentoContext;